import React from 'react'
import styled from 'styled-components'
import { useState, useEffect } from 'react'
import { PromotionAPI } from '@api'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import moment from 'moment'
import './PromotionDetail.scss'
import { HeaderSection, FooterSection, LeafBox, Accordion } from '@components'

import { TitleComponent } from '../../common/components/TitleComponent'

const Container = styled.div`
  background-color: #ffffff;
  padding-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const TitleRightContent = styled.h4`
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #85714d;
  margin-bottom: 18px;
`

const Desktop = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
`

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`

const DetailTitle = styled.div`
  font-size: 32px;
  color: #85714d;
  margin-bottom: 20px;
  @media screen and (max-width: 767px) {
    margin-bottom: 10px;
  }
`

const RightBox = styled.div`
  background: #ffffff;
  box-shadow: 0px -1px 2px rgba(0, 0, 0, 0.05), 0px 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  padding: 16px;

  @media screen and (max-width: 767px) {
    margin-top: 24px;
  }
`

const MenuItem = styled.a`
  text-decoration: none;

  &:hover {
    p {
      color: #ffb81c;
    }
  }

  &:last-child {
    p {
      margin-bottom: 0;
      padding-bottom: 0;
      border-bottom: none;
    }
  }

  h5 {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #5e514d;
    margin-bottom: 12px;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  p {
    ont-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #8a8d8f;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 1px solid #edeeee;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`

const PromotionDetail = function () {
  const { t, i18n } = useTranslation()
  const { id } = useParams()
  const [isLoading, setisLoading] = useState(false)
  const [promotionDetails, setPromotionDetails] = useState([{}])
  const [anotherItems, setanotherItems] = useState([{}])
  const [anotherPromotionList, setAnotherPromotionList] = useState([{}])

  const loadPromotionDataList = async function () {
    const promotionData = await PromotionAPI('')
    setAnotherPromotionList(promotionData.data.data)
  }

  useEffect(() => {
    loadPromotionDataList()
  }, [])

  const loadDataById = async function () {
    setisLoading(true)
    const promotionDetail = await PromotionAPI(`/detail/${id}`)
    setPromotionDetails(promotionDetail.data.data.item)
    setanotherItems(promotionDetail.data.data.another_items)
    setisLoading(false)
  }

  useEffect(() => {
    loadDataById()
  }, [])

  const modifiedDate = moment(promotionDetails.expiredDate).format(
    'DD MMMM YYYY'
  )

  return (
    <Container>
      <TitleComponent title={promotionDetails.title} />

      {/* <Desktop>
        <HeaderSection
          group={t("solusi_masa_depan_anda")}
          title={promotionDetails.title}
          description={promotionDetails.description}
          banner={promotionDetails.imageDesktop}
          showButton={false}
          textButton={t("dapatkan_kartu_kredit_sekarang")}
        />
      </Desktop>

      <Mobile>
        <HeaderSection
          group={t("solusi_masa_depan_anda")}
          title={promotionDetails.title}
          description={promotionDetails.description}
          banner={promotionDetails.imageMobile}
          showButton={false}
          textButton={t("dapatkan_kartu_kredit_sekarang")}
        />
      </Mobile> */}

      <div className="p-0 m-0 container-fluid">
        <div className="mb-4 mb-lg-0 mx-0 px-lg-5 mx-lg-5 flex align-items-center position-relative row">
          <div className="mt-5 mb-4 row">
            <div className="col-md-7">
              <DetailTitle>{promotionDetails.title}</DetailTitle>
              <div className="d-flex flex-row align-items-en">
                <div className="author-and-category-label">{t('oleh')}</div>
                <div className="author-and-category">
                  {promotionDetails.author === 'BANK BUKOPIN'
                    ? 'KB Bank'
                    : promotionDetails.author}
                </div>
                <div className="author-and-category-label">{t('di_')}</div>
                <div className="author-and-category">
                  {promotionDetails.category}
                </div>
              </div>
              <div className="mb-3 modifed-date">{modifiedDate}</div>
              <Desktop>
                <img
                  src={promotionDetails.imageDesktop}
                  alt=""
                  style={{ width: '100%' }}
                />
              </Desktop>
              <Mobile>
                <img
                  src={promotionDetails.imageMobile}
                  alt=""
                  style={{ width: '100%' }}
                />
              </Mobile>
              <div className="mt-2 image-description">
                {promotionDetails.shortDescription}
              </div>
              <div
                className="mt-2"
                dangerouslySetInnerHTML={{
                  __html: promotionDetails.fullDescription,
                }}
              ></div>
            </div>
            <div className="col-md-1"></div>
            <div className="col-md-4">
              <RightBox>
                <TitleRightContent>{t('promosi-lainnya')}</TitleRightContent>
                {anotherPromotionList?.item?.slice(0, 5).map((item) => {
                  return (
                    <MenuItem href={`/promotion/detail/${item.id}`}>
                      <h5>{item?.title}</h5>
                      <p>{item?.shortDescription}</p>
                    </MenuItem>
                  )
                })}
              </RightBox>
            </div>
          </div>
        </div>
      </div>
      <FooterSection currentPage={t('promosi')} />
    </Container>
  )
}

export default PromotionDetail
